import { LanguageType } from 'types/enum';

export default {
    [LanguageType.zhCN]: import('m-ui/es/locale/zh_CN'),
    [LanguageType.enUS]: import('m-ui/es/locale/en_US')
};
